import utils from "@/utils/utils"
export default {
  namespaced: true,
  state: {
    cOrderSn: null,
    checkedReturnType: sessionStorage.getItem('checkedReturnType') || '', // 选中的售后类型
    typeActual: utils.strJSONParse(sessionStorage.getItem('typeActual')) || [],
    productInfo: utils.strJSONParse(sessionStorage.getItem('productInfo')) || {},// 商品信息
  },
  getters: {
    
  },
  mutations: {
    setCOrderSn(state, cOrderSn) {
      state.cOrderSn = cOrderSn
    },
    setCheckedReturnType(state, type) {
      state.checkedReturnType = type
      sessionStorage.setItem('checkedReturnType', type)
    },
    setTypeActual(state, type) {
      state.typeActual = type
      sessionStorage.setItem('typeActual', JSON.stringify(type))
    },
    setProductInfo(state, productInfo) {
      state.productInfo = productInfo
      sessionStorage.setItem('productInfo', JSON.stringify(productInfo))
    },
  },
}
